import { AdditionalFieldData } from "./AdditionalFieldData";

export class Attendee {
  id: number = 0;
  salutation?: string;
  firstname: string = '';
  lastname: string = '';
  email: string = '';
  contactPhone?: string;
  additionalFieldData: AdditionalFieldData[] = [];

  public static createFromJson(input: any): Attendee {
    const data = new Attendee();
    data.fromJson(input);
    return data;
  }

  fromJson(input: any) {
    this.id = input["id"];
    this.salutation = input["salutation"];
    this.firstname = input["firstname"];
    this.lastname = input["lastname"];
    this.email = input["email"];
    this.contactPhone = input["contactPhone"];
    if (input['additionalFieldData']) {
      for (const child of input['additionalFieldData']) {
        this.additionalFieldData.push(AdditionalFieldData.createFromJson(child));
      }
    }
  }

  toJson(): any {
    return {
      id: this.id,
      salutation: this.salutation,
      firstname: this.firstname,
      lastname: this.lastname,
      email: this.email,
      contactPhone: this.contactPhone,
      additionalFieldData: this.additionalFieldData.map(value => value.toJson())
    };
  }
}
